import index from "./examInvoiceAccept.vue";
export default index;
